import { render } from "./SystemComponent.vue?vue&type=template&id=3d3afc1f&scoped=true"
import script from "./SystemComponent.vue?vue&type=script&lang=js"
export * from "./SystemComponent.vue?vue&type=script&lang=js"

import "./SystemComponent.vue?vue&type=style&index=0&id=3d3afc1f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3afc1f"],['__file',"resources/js/components/admin/settings/System/SystemComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d3afc1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d3afc1f', __exports__)) {
    api.reload('3d3afc1f', __exports__)
  }
  
  module.hot.accept("./SystemComponent.vue?vue&type=template&id=3d3afc1f&scoped=true", () => {
    api.rerender('3d3afc1f', render)
  })

}


export default __exports__